module.exports = __webpack_public_path__ + "static/media/close_quote.6693dbd2.svg";